'use strict';

module.exports = Backbone.Model.extend({
    defaults: {
        baggageInformation: null,
        membershipDTO: {},
    },
    connect: true,
    selectors: ['hasTrains'],
});
